import { render, staticRenderFns } from "./UpdatePrice.vue?vue&type=template&id=2532dc6c&scoped=true&"
import script from "./UpdatePrice.vue?vue&type=script&lang=js&"
export * from "./UpdatePrice.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePrice.vue?vue&type=style&index=0&id=2532dc6c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2532dc6c",
  null
  
)

export default component.exports